export default "__VITE_ASSET__I72yYSWt__ 740w";